import React from 'react'
import { SimpleForm, Field } from 'shared/ui/SimpleForm'
import Heading from 'shared/ui/Heading'
import { Columns, Column } from 'react-flex-columns'
import subscribeToMailingList from '../../utils/subscribeToMailingList'

export default function FreeWorkshopSignupForm({ ws, children }) {
  if (!ws.convertKitFormId) {
    throw Error('Invalid Workshop ConvertKit ID for Registration Form')
  }

  function handleSubmit(fields) {
    return subscribeToMailingList(ws.convertKitFormId, fields).then(() => {
      return {
        message:
          "Your registration is complete. We'll send you an email with a link to view the event within a few days of it starting.",
      }
    })
  }

  return (
    <Columns as="section" gutterSize={4}>
      <Column flex>
        <Heading size={3}>Free {ws.minutes}-minute Workshop</Heading>
        {children}
      </Column>
      <Column flex>
        <SimpleForm onSubmit={handleSubmit}>
          <Field name="first_name" label="First Name" placeholder="Jane" required />
          <Field name="email" type="email" label="Email" placeholder="jane@email.com" required />
          <button type="submit" className="button block">
            Register
          </button>
        </SimpleForm>
      </Column>
    </Columns>
  )
}
